import { ErrorFile } from './errorFile';
import { UnitsReferenceEnum } from './interwinnerResult';

export class ErrorInterwinnerFile extends ErrorFile {
  unitsReferenceFileName: string;
  unitsReferenceEnum: UnitsReferenceEnum;

  constructor(
    message: string,
    fileName: string,
    unitsReferenceFileName: string,
    unitsReferenceEnum: UnitsReferenceEnum
  ) {
    super(message, fileName);
    this.unitsReferenceFileName = unitsReferenceFileName;
    this.unitsReferenceEnum = unitsReferenceEnum;
  }
}
